// extracted by mini-css-extract-plugin
module.exports = {"offer":"offerPage_offer__3OsUe","btn":"offerPage_btn__311M-"};